import React, {createContext, useEffect, useState} from "react";

import api from "../utils/api";

import {useCookies} from "react-cookie";

function currentUiLanguage() {
	if (typeof document !== "undefined") {
		const lang = document.documentElement.getAttribute("lang");
		if (lang) {
			return lang;
		}
	}
	return "et";
}

export const authContext = createContext({
	isLoggedIn: false,
});

export function ProvideAuth({children}) {
	const auth = useProvideAuth();
	return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

function useProvideAuth() {
	const [cookies, setCookie, removeCookie] = useCookies(["token", "id"]);
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [rememberMe, setRememberMe] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const token = cookies["token"];
	const idUser = cookies["id"];
	
	useEffect(() => {
		// No token -> not logged in
		if (!token) {
		  setIsLoggedIn(false);
		  setIsLoading(false);
		  return;
		}
	  
		// Token exists but id not yet written -> wait for next render
		if (!idUser) {
		  setIsLoading(true);
		  return;
		}
	  
		setIsLoading(true);
	  
		api.getUserGuides(token, { id: idUser }, currentUiLanguage())
		  	.then(() => {
				setIsLoggedIn(true);
				setIsLoading(false);
		  	})
		  	.catch(() => {
				removeCookie("token", { path: "/" });
				removeCookie("id", { path: "/" });
				setIsLoggedIn(false);
				setIsLoading(false);
		  	});
	  
	}, [token, idUser, removeCookie]);

	const signIn = (email, password, language) => {
		return api.login({email: email, password: password}, language).then((res) => {
			if (res.errors) {
				return res.errors;
			} else {

				if (rememberMe) {
					const yearInSeconds = 31556952;
					setCookie("token", res.token, {path: "/", maxAge: yearInSeconds});
					setCookie("id", res.id, {path: "/", maxAge: yearInSeconds});
				} else {
					setCookie("token", res.token, {path: "/"});
					setCookie("id", res.id, {path: "/"});
				}

				return res.token;
			}
		});
	};

	const logout = (callback) => {
		setIsLoggedIn(false);
		removeCookie("token", { path: "/" });
		removeCookie("id", { path: "/" });
		callback();
	};

	return {
		signIn,
		logout,
		token,
		idUser,
		isLoggedIn,
		setRememberMe,
		isLoading,
		setIsLoading,
	};
}
